<template>
  <div id="app">
    <!-- <topbar></topbar> -->
    <navbar></navbar>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <FooterN />
  </div>
</template>

<script>
import Topbar from '@/components/header/Topbar'
import Navbar from '@/components/header/Navbar'
import FooterN from '@/components/footer/FooterN'
export default {
  name: 'App',
  components: {
    Topbar,
    Navbar,
    FooterN
  }
}
</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  font-family: 'Poppins', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.text-title {
  font-size: 40px;
}
.text-desc {
  padding: 30px 0;
  margin-bottom: 0;
  color: #555;
}
</style>



// WEBPACK FOOTER //
// src/App.vue